export default __webpack_public_path__ + "css/howest-theme.min.css";